import { post, get } from './http'
// import qs from 'qs'

//获取竞赛规程
export function getRaceRule(page, limit) {
  return post('/tyapi/pc/group/getSportRaceRule', {
    page: page,
    limit: limit,
  })
}
//竞赛规程详情
export const getRaceRuleDetail = (id) =>
  post('/tyapi/pc/group/getSportRaceRuleDetail', {
    id: id,
  })
//获取竞赛活动
export function getRaceInfo(page, limit) {
  return post('/tyapi/pc/group/getSportRace', {
    page: page,
    limit: limit,
  })
}
//竞赛活动详情
export const getRaceDetail = (id) =>
  post('/tyapi/pc/group/getSportRaceDetail', {
    id: id,
  })

//文章详情
export const getArticleDetail = (id) => post('/tyapi/pc/cms/cmscontent/' + id)

//增加点击量
export const addClicks = (id) => post('/tyapi/pc/cms/addClicks/' + id)

//cms列表
export const getCmsList = (currBlock, currPage, limitNum) =>
  post('/tyapi/pc/cms/list/', {
    cmsCode: currBlock,
    page: currPage,
    limit: limitNum,
  })

//全部社团
export const getAllClub = () => get('/tyapi/pc/club/getAllClub')

//社团详情
export const getClubInfo = (associationId) =>
  post('/tyapi/pc/club/associationInfo/', {
    associationId: associationId,
  })

//部门概况
export const getDepartment = () => post('/tyapi/pc/department/department/')

//教师照片列表
export const getTeachers = (currPage, limitNum) =>
  post('/tyapi/pc/group/getTeachers/', {
    page: currPage,
    limit: limitNum,
  })

//教师详情
export const getTeacherInfo = (teacherId) =>
  post('/tyapi/pc/department/teacherBaseInfo/', {
    teacherId: teacherId,
  })

//领导照片列表
export const getLeaders = (currPage, limitNum) =>
  post('/tyapi/pc/department/teacherInfo/', {
    page: currPage,
    limit: limitNum,
  })

//教授照片列表
export const getProfessor = (currPage, limitNum) =>
  post('/tyapi/pc/cms/getProfessor/', {
    page: currPage,
    limit: limitNum,
  })

//党政表格
export const getPartyGov = (currPrograma) =>
  post('/tyapi/pc/department/leaderInfo/', {
    title: currPrograma,
  })

//党政部门个数
export const getOrganizations = () =>
  post('/tyapi/pc/department/organizations/')

//首页list
export const getHomeLists = () => get('/tyapi/pc/cms/HomePageContent')

//轮播
export const getSwiper = (cmsCode, page, limit) =>
  post('/tyapi/pc/cms/rotate/list', {
    cmsCode: cmsCode,
    page: page,
    limit: limit,
  })

//搜索
export const getSearch = (currSearchKey, page, limit) =>
  post('/tyapi/pc/cms/searchContent', {
    keyword: currSearchKey,
    page: page,
    limit: limit,
  })

//视频详情
export const getVideoInfo = (id) =>
  post('/tyapi/pc/group/getVideo', {
    id: id,
  })

//视频列表
export const getVideoList = (currPage, limit, choseItem) =>
  post('/tyapi/pc/group/getVideoList', {
    page: currPage,
    limit: limit,
    typeIds: choseItem,
  })

//视频类型
export const getVideoTypes = () => get('/tyapi/pc/group/getVideoType')

//代表队
export const teamInfo = () => get('/tyapi/pc/competition/teamInfo')

//代表队详情
export const teamBaseInfo = (teamId) =>
  post('/tyapi/pc/competition/teamBaseInfo/', {
    teamId: teamId,
  })
